import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import Behavior from "./Behavior";
import { useState, useEffect } from "react";
import Helpers from "@/Helpers";

export default function Behaviors(props) {
   const { sectionData, setValue, values } = props;
   
   // State for the currently focused input
   const [currentInput, setCurrentInput] = useState({ id: null, value: '' });
   const currentSection = sectionData?.currentSection;
   useEffect(() => {
      sectionData?.registerSection?.();
   }, [currentSection?.name]);

   const content: Record<string, string> = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(content);
   const contentItems = Array.isArray(elements?.items) ? elements.items : [];
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");
   const additionalInstructions = Helpers.getSectionHtmlValue(content, "additionalInstructions");

   useEffect(() => {
      sectionData?.registerSection(767, contentItems.length);
   }, [sectionData?.currentSection?.id]);

   function setValueAsync(childId, value) {
      if (setValue) {
         setValue(childId, value);
      } else {
         if (sectionData && sectionData.onAnswer) {
            sectionData.onAnswer(childId, value);
         }
      }
   }
   
   function handleInputFocus(inputId) {
      setCurrentInput({ 
         id: inputId, 
         value: values[currentSection.formId + inputId] || '' 
      });
   }
   
   function handleInputChange(value) {
      setCurrentInput(prev => ({ ...prev, value }));
   }
   
   function handleInputBlur() {
      if (currentInput.id !== null) {
         setValueAsync(currentInput.id, currentInput.value);
         setCurrentInput({ id: null, value: '' });
      }
   }

   return (
      <div className="behaviors page" >
         <div className="instructions left">
            {parseSanitizedHtml(instructionsHtml)}
         </div>
         <div className="content">
                  {contentItems.map((a, i) => {
                     return (
                        <Behavior
                           key={i}
                           id={a.id}
                           name={a.name}
                           value={values[a.id + currentSection.formId] === "T"}
                           setValue={setValueAsync}
                        />
                     );
                  })}
         </div>
         <div className="field additionals">
            <label>{additionalInstructions}</label>
            <div><input type="text" 
               className="additionalBehavior"
               aria-label="Additional behavior response 1"
               placeholder=""
               value={currentInput.id === 20 ? currentInput.value : (values[currentSection.formId + 20] || '')} 
               onFocus={() => handleInputFocus(20)}
               onChange={e => handleInputChange(e.target.value)} 
               onBlur={handleInputBlur} /></div>
            <div><input type="text" 
               className="additionalBehavior"
               aria-label="Additional behavior response 2"
               placeholder=""
               value={currentInput.id === 21 ? currentInput.value : (values[currentSection.formId + 21] || '')} 
               onFocus={() => handleInputFocus(21)}
               onChange={e => handleInputChange(e.target.value)} 
               onBlur={handleInputBlur} /></div>
            <div><input type="text" 
               className="additionalBehavior"
               aria-label="Additional behavior response 3"
               placeholder=""
               value={currentInput.id === 22 ? currentInput.value : (values[currentSection.formId + 22] || '')} 
               onFocus={() => handleInputFocus(22)}
               onChange={e => handleInputChange(e.target.value)} 
               onBlur={handleInputBlur} /></div>
            <div><input type="text" 
               className="additionalBehavior"
               aria-label="Additional behavior response 4"
               placeholder=""
               value={currentInput.id === 23 ? currentInput.value : (values[currentSection.formId + 23] || '')} 
               onFocus={() => handleInputFocus(23)}
               onChange={e => handleInputChange(e.target.value)} 
               onBlur={handleInputBlur} /></div>
         </div>
      </div>
   );
}

